const { getOffsetTop } = window.BAO.Utils

class FeatureSet extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setOverlayOpacity()
  }

  setOverlayOpacity () {
    if (!this.offsetHeight) return

    const maxOpacity = window.BAO.MediaBreakpoints.isXsViewport ? 1 : 0.8

    const elementStartPoint = getOffsetTop(this)
    const elementEndPoint = getOffsetTop(this) + window.innerHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.els.overlay.element.style.setProperty('--Overlay', '0')

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.els.overlay.element.style.setProperty('--Overlay', maxOpacity)

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const opacityAmount = maxOpacity * scrollYAsAPercentageOfJourney

    this.els.overlay.element.style.setProperty('--Overlay', opacityAmount)
  }
}

if (!customElements.get('feature-set')) {
  customElements.define('feature-set', FeatureSet)
}
